/* eslint-disable no-empty */
export function setItem(key, item) {
  try {
    sessionStorage.setItem(key, item);
  } catch (e) {}
}
export function getItem(key) {
  var retVal;

  try {
    retVal = sessionStorage.getItem(key);
  } catch (_e) {
    retVal = null;
  }

  return retVal;
}
export function removeItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {}
}